import React, { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import _ from 'lodash';
import * as budgetApi from '../../lib/api/budget';
// mui
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

//table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';

import { getYearOptions, thisYear } from '../../utils/calcDatetime';
import { useDispatch, useSelector } from 'react-redux';
import { getNumberComma } from '../../utils/numberUtils';
import NumberFormatText from '../../components/common/form/NumberFormatText';
import { listDeparts, treeDeparts } from '../../modules/deptModule/departs';
import { useBoolean } from '../../hooks/useBoolean';
import TeamBudgetUploadModalContainer from './TeamBudgetUploadModalContainer';
import { downloadFile } from '../../utils/fileCodeUtils';
import AskDialog from '../../components/common/dialog/AskDialog';

//---------------------------------------------------
const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
    },
  },
});
//---------------------------------------------------
const initHqBudgetData = {
  year: null,
  hqUuid: null,
  teamUuid: null,
  costs: [
    {
      id: 1,
      name: '복리후생비',
      rowSpan: 14,
      children: [
        { id: 1, name: '워크샵(동계)', desc: '동계(1000만원 * 1회)', cost: 0 },
        { id: 2, name: '체육대회', desc: '1,000만원 * 1회', cost: 0 },
        { id: 3, name: '송년회', desc: '10만원 *  60', cost: 0 },
        { id: 4, name: '월례행사', desc: '20만원 * 12회', cost: 0 },
        { id: 5, name: '부식비', desc: '20만원 * 12회', cost: 0 },
        { id: 6, name: '직원경조사비', desc: '20만원 * 12회', cost: 0 },
        { id: 7, name: '직원화환(축하,근조)', desc: '20만원 * 12회', cost: 0 },
        { id: 8, name: '팀원명절선물', desc: '10만원 *  60명 * 2회', cost: 0 },
        { id: 9, name: '본부장명절선물', desc: '25만원 *  6명 * 2회', cost: 0 },
        { id: 10, name: '상비약 구입', desc: '5만원 * 4회', cost: 0 },
        { id: 11, name: '네스카페 커피캡슬', desc: '20만원 * 12회', cost: 0 },
        {
          id: 12,
          name: '우수사원 포상금(연말 시상)',
          desc: '인상 400만원, 영업우수상 200만원, 지원부문 100만원 * 4명',
          cost: 0,
        },
        {
          id: 13,
          name: '우수사원 포상금(월별우수상)',
          desc: '우수사원 월별 시상 (50만원 * 10회)',
          cost: 0,
        },
        {
          id: 14,
          name: '공동근로복지기금',
          desc: '5,000만원 * 2회',
          cost: 0,
        },
      ],
    },
    {
      id: 2,
      rowSpan: 2,
      name: '접대비',
      children: [
        //접대비
        {
          id: 1,
          name: '경조사 화환',
          desc: '경조사화환 10만원 * 20회',
          cost: 0,
        },
        {
          id: 2,
          name: '조의금',
          desc: '조의금 20만원 * 20회',
          cost: 0,
        },
      ],
    },
    {
      id: 3,
      rowSpan: 8,
      name: '지급수수료',
      children: [
        {
          id: 1,

          name: '프로그램 사용료(MS-OFFICE)',

          desc: '',
          cost: 0,
        },
        {
          id: 2,

          name: '프로그램 이용료(그룹웨어)',

          desc: '30만원 * 12회',
          cost: 0,
        },
        {
          id: 3,

          name: '프로그램 이용료(더존 ERP 프로그램)',

          desc: '300만원(유지보수료), 400만원(클라우드사용료)',
          cost: 0,
        },
        {
          id: 4,

          name: '회계기장비용',

          desc: '60만원*12회',
          cost: 0,
        },
        {
          id: 5,

          name: '세무조정료',

          desc: '',
          cost: 0,
        },
        {
          id: 6,

          name: '신용평가갱신',

          desc: '',
          cost: 0,
        },
        {
          id: 7,

          name: '기타지급수수료',

          desc: '200만원 * 12회',
          cost: 0,
        },
        {
          id: 8,

          name: '은행지급수수료',

          desc: '',
          cost: 0,
        },
      ],
    },
    {
      id: 4,
      name: '이자비용',
      rowSpan: 19,
      children: [
        {
          id: 1,
          name: '기타원화지급보증(하나-045)',
          desc: '',
          cost: 0,
        },
        {
          id: 2,

          name: 'KB 우수기술기업 TCB신용대출(국민-101)',

          desc: '',
          cost: 0,
        },
        {
          id: 3,

          name: '일반자금대출(일시상환) 일자리창출기업(신한-723)',

          desc: '',
          cost: 0,
        },
        {
          id: 4,

          name: '기타중소운전자금대출(기업-032)',

          desc: '',
          cost: 0,
        },

        {
          id: 5,

          name: '기업구매카드',

          desc: '',
          cost: 0,
        },
        {
          id: 6,

          name: '기업운전일반자금대출(우리-194)',

          desc: '',
          cost: 0,
        },

        {
          id: 7,

          name: '기업운전일반자금대출(우리-512)',

          desc: '',
          cost: 0,
        },

        {
          id: 8,

          name: '우리CUBE론-X/일반(신규)-운전(일시)(우리-352)',

          desc: '',
          cost: 0,
        },
        {
          id: 9,

          name: '우리CUBE론-X/일반(신규)-운전(일시)(우리-801)',

          desc: '',
          cost: 0,
        },

        {
          id: 10,

          name: '정보통신진흥기금(기술담보-중소기업-(우리633)',

          desc: '',
          cost: 0,
        },
        {
          id: 11,

          name: '우리CUBE론-X/일반(신규)-시설(일시)(우리-979)',

          desc: '',
          cost: 0,
        },

        {
          id: 12,

          name: '일반자금대출(기타시설일반)(대구-204-8)',

          desc: '',
          cost: 0,
        },
        {
          id: 13,

          name: '일반자금대출(기타운전일반)(대구-206-2)',

          desc: '',
          cost: 0,
        },

        {
          id: 14,

          name: '하나은행',

          desc: '',
          cost: 0,
        },

        {
          id: 15,

          name: '보험납부금 담보 대출(흥국)',

          desc: '',
          cost: 0,
        },
        {
          id: 16,

          name: '탑플러스 기업대출(경남-896-04)',

          desc: '',
          cost: 0,
        },

        {
          id: 17,

          name: '탑플러스 기업대출(경남-889-04)',

          desc: '',
          cost: 0,
        },
        {
          id: 18,

          name: '보험납부금 담보 대출(메트라이프)',

          desc: '',
          cost: 0,
        },
        {
          id: 19,

          name: '10억 대출(김진호)',

          desc: '',
          cost: 0,
        },
      ],
    },
    {
      id: 5,
      name: '세금과공과',
      rowSpan: 5,
      children: [
        //세금과공과
        {
          id: 1,

          name: '교통유발부담금',

          desc: '서울(10만원)',
          cost: 0,
        },
        {
          id: 2,

          name: '법인세',

          desc: '',
          cost: 0,
        },
        {
          id: 3,

          name: '종업원할사업소세',

          desc: '',
          cost: 0,
        },
        {
          id: 4,

          name: '면허세',

          desc: '200만원 * 12회',
          cost: 0,
        },
        {
          id: 5,

          name: '각종기타세금',

          desc: '2.7만원',
          cost: 0,
        },
      ],
    },
    {
      id: 6,
      name: '협회비',
      rowSpan: 2,
      children: [
        {
          id: 1,
          name: '한국소프트웨어 산업협회비',
          desc: '',
          cost: 0,
        },
        {
          id: 2,
          name: '한국통신공사협회비',
          desc: '',
          cost: 0,
        },
      ],
    },
    {
      id: 7,
      name: '예비비',
      rowSpan: 1,
      children: [
        {
          id: 1,
          name: '예비비',

          desc: '',
          cost: 0,
        },
      ],
    },
  ],
};
const initHqData = [
  {
    companyCd: 'bitoplus',
    headquarters: [
      { dptUuid: '90643615-5ce3-11ec-9987-0275bfbe2398', dptNm: '대표이사' },
      {
        dptUuid: '5B157EB9-1A0E-4EF1-9EB5-3311EC9DC852',
        dptNm: '경영기획본부',
      },
      {
        dptUuid: 'D6D83465-EDF3-450D-ADEB-906BDD9FD086',
        dptNm: '기술지원본부',
      },
      {
        dptUuid: '472FA776-BCC4-4BF4-A2FC-B2F6B2ACD616',
        dptNm: '전략사업본부',
      },
      { dptUuid: 'BBB839D7-8193-4C29-96FC-527EE239FB8A', dptNm: 'SI사업본부' },
    ],
  },
  {
    companyCd: 'bts',
    headquarters: [
      { dptUuid: '90643615-5ce3-11ec-9987-0275bfbe2398', dptNm: '대표이사' },
      {
        dptUuid: '5B157EB9-1A0E-4EF1-9EB5-3311EC9DC852',
        dptNm: '경영기획본부',
      },
    ],
  },
  {
    companyCd: 'mega',
    headquarters: [
      { dptUuid: '90643615-5ce3-11ec-9987-0275bfbe2398', dptNm: '대표이사' },
      {
        dptUuid: '5B157EB9-1A0E-4EF1-9EB5-3311EC9DC852',
        dptNm: '경영기획본부',
      },
      {
        dptUuid: '472FA776-BCC4-4BF4-A2FC-B2F6B2ACD616',
        dptNm: '전략사업본부',
      },
    ],
  },
];
const arrYears = getYearOptions(3, 3);
const defaultYear = thisYear;

//---------------------------------------------------
const TeamBudgetInputContainer = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const { user, departs } = useSelector(({ auth, departModule }) => ({
    user: auth.user,
    departs: departModule.departs.list,
  }));
  const [selectedYear, setSelectedYear] = useState(defaultYear);
  const [selectedHq, setSelectedHq] = useState('');
  const [selectedTeam, setSelectedTeam] = useState('');

  const [currentCostsData, setCurrentCostsData] = useState(null);

  const [companyHqOptions, setCompanyHqOptions] = useState([]);
  const [HqTeamOptions, setHqTeamOptions] = useState([]);

  const showDelDialog = useBoolean();
  const [selectedDel, setSelectedDel] = useState(null);

  const isLoading = useBoolean();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!departs || departs.length === 0) {
      dispatch(listDeparts());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departs]);

  const onLoadData = useCallback(async () => {
    isLoading.onTrue();

    try {
      const res = await budgetApi.getTeamBudget({
        year: selectedYear,
        dptUuid: selectedTeam,
      });
      if (res.data?.info) {
        const costsData = { ...res.data?.info };
        costsData.year = selectedYear;
        costsData.hqUuid = selectedHq;
        costsData.teamUuid = selectedTeam;

        console.log(JSON.stringify(costsData, null, 2));
        setCurrentCostsData(costsData);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
    isLoading.onFalse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear, selectedHq, selectedTeam]);

  useEffect(() => {
    if (selectedYear && selectedHq && selectedTeam) {
      // const costsData = { ...initHqBudgetData };
      // costsData.year = selectedYear;
      // costsData.hqUuid = selectedHq;
      // costsData.teamUuid = selectedTeam;
      // console.log(JSON.stringify(costsData, null, 2));
      // setCurrentCostsData(costsData);
      onLoadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear, selectedHq, selectedTeam]);

  useEffect(() => {
    const findCompanyHq = _.find(
      initHqData,
      (hq) => hq.companyCd === user?.companyCd,
    );
    setCompanyHqOptions(findCompanyHq.headquarters);
  }, [user]);

  //본부 선택
  const handleChangeHq = (newValue) => {
    setSelectedHq(newValue);
    const filteredList = departs.filter(
      (dp) => dp.parentDptUuid === newValue && dp.useYn === 'Y',
    );

    //
    setHqTeamOptions(filteredList);
    setCurrentCostsData(null);
    //setSelectedTeam(filteredList[0]?.dptUuid);
  };

  const handleChange = (newValue, parent, child, name) => {
    const prevCost = [...currentCostsData.costs];
    const findLarge = prevCost.find((large) => large.id === parent.id);
    const updateData = { ...child, [name]: newValue };
    const filteredChildren = findLarge.children.filter(
      (item) => item.id !== child.id,
    );
    const updateChildren = _.orderBy([...filteredChildren, updateData], ['id']);

    const filteredList = prevCost.filter((item) => item.id !== parent.id);
    const updateList = _.orderBy(
      [...filteredList, { ...parent, children: updateChildren }],
      ['id'],
    );
    setCurrentCostsData((prevData) => ({ ...prevData, costs: updateList }));
  };

  const handleSave = async () => {
    console.log(JSON.stringify(currentCostsData, null, 2));
    try {
      const res = await budgetApi.saveTeamBudget(currentCostsData);
      if (res.data.result === 'success' && res.data?.info) {
        const costsData = { ...res.data?.info };
        costsData.year = selectedYear;
        costsData.hqUuid = selectedHq;
        costsData.teamUuid = selectedTeam;

        setCurrentCostsData(costsData);
        enqueueSnackbar(`팀의 예산이 저장되었습니다`, {
          variant: 'success',
        });
      } else {
        const msg = res.data.message
          ? res.data.message
          : `팀의 예산 저장에 실패하였습니다.`;
        enqueueSnackbar(msg, {
          variant: 'error',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const handleDelete = async () => {
    console.log(selectedDel);
    try {
      const res = await budgetApi.deleteTeamBudget(selectedDel);
      if (res.data.result === 'success') {
        onLoadData();
        enqueueSnackbar(`계정이 삭제 저장되었습니다`, {
          variant: 'success',
        });
        setSelectedDel(null);
      } else {
        const msg = res.data.message
          ? res.data.message
          : `계정삭제에 실패하였습니다.`;
        enqueueSnackbar(msg, {
          variant: 'error',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const handleReset = () => {
    setSelectedYear(defaultYear);
    setSelectedHq('');
    setSelectedTeam('');
    setCurrentCostsData(null);

    setCompanyHqOptions([]);
    setHqTeamOptions([]);
  };

  let total = 0;
  if (currentCostsData?.costs.length) {
    const arr = [];
    currentCostsData?.costs.map((large) => {
      return large?.children.map((small) => arr.push(+small.cost));
    });
    total = _.sum(arr);
  }

  const showUpload = useBoolean();
  // upload
  const handleUpload = useCallback(() => {
    showUpload.onTrue();
  }, [showUpload]);

  const handleDownload = async () => {
    try {
      const blob = await budgetApi.downloadExlByTeamBudget({
        year: selectedYear,
      });
      const filename = blob.headers['filename'];

      downloadFile(blob, decodeURIComponent(filename), 'xlsx');
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const refreshOnClose = () => {
    showUpload.onFalse();
    // dispatch(listSalesCosts(makeFilters(defaultFilters)));
  };

  return (
    <Box>
      <Stack spacing={2}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="flex-end"
          sx={{
            py: 1,
          }}
        >
          <Button variant="contained" color="success" onClick={handleUpload}>
            업로드
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDownload}
          >
            다운로드
          </Button>
        </Stack>
        <Stack
          spacing={1}
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          sx={{
            width: '100%',
            bgcolor: 'grey.50',
            borderColor: 'grey.300',
            p: 1,
            m: 1,
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{
              py: 1,
            }}
          >
            <Box sx={{ width: '40%', textAlign: 'center' }}>
              <Typography variant="subtitle2">적용년도</Typography>
            </Box>
            <Box>
              <FormControl variant="standard" size="small" fullWidth>
                <Select
                  variant="outlined"
                  size="small"
                  labelId="selected-year-label"
                  id="selected-year"
                  displayEmpty
                  sx={{ width: 120 }}
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  {arrYears &&
                    arrYears.map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{
              py: 1,
            }}
          >
            <Box sx={{ width: '40%', textAlign: 'center' }}>
              <Typography variant="subtitle2">본부</Typography>
            </Box>
            <Box>
              <FormControl variant="standard" size="small" fullWidth>
                <Select
                  variant="outlined"
                  size="small"
                  labelId="selected-hq-label"
                  id="selected-hq"
                  displayEmpty
                  sx={{ width: 240 }}
                  value={selectedHq || ''}
                  onChange={(e) => handleChangeHq(e.target.value)}
                >
                  <MenuItem value="">본부를 선택하세요</MenuItem>
                  {companyHqOptions &&
                    companyHqOptions.map((option) => (
                      <MenuItem key={option.dptUuid} value={option.dptUuid}>
                        {option.dptNm}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{
              py: 1,
            }}
          >
            <Box sx={{ width: '40%', textAlign: 'center' }}>
              <Typography variant="subtitle2">팀</Typography>
            </Box>
            <Box>
              <FormControl variant="standard" size="small" fullWidth>
                <Select
                  variant="outlined"
                  size="small"
                  labelId="selected-team-label"
                  id="selected-team"
                  displayEmpty
                  sx={{ width: 240 }}
                  value={selectedTeam || ''}
                  onChange={(e) => setSelectedTeam(e.target.value)}
                >
                  <MenuItem value="">팀을 선택하세요</MenuItem>
                  {HqTeamOptions &&
                    HqTeamOptions.map((option) => (
                      <MenuItem key={option.dptUuid} value={option.dptUuid}>
                        {option.dptNm}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>
        </Stack>
        {!currentCostsData && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="subtitle2">
              년도와 본부와 팀을 선택하세요.
            </Typography>
          </Box>
        )}
        {currentCostsData && (
          <Box
            sx={{
              width: '100%',
              p: 2,
              m: 1,
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ py: 1 }}
            >
              <Button variant="contained" color="warning" onClick={handleReset}>
                초기화
              </Button>

              <Button variant="contained" color="primary" onClick={handleSave}>
                저장
              </Button>
            </Stack>
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={1}
              sx={{ py: 1 }}
            >
              <Typography variant="subtitle2">합계</Typography>
              <Typography variant="subtitle2">
                {getNumberComma(total)} 원
              </Typography>
            </Stack>
            <TableContainer
              component={Paper}
              sx={{ bgcolor: 'grey.50', borderColor: 'grey.300' }}
            >
              <Table
                sx={{ minWidth: 650 }}
                aria-label="total overhead costs"
                size="small"
                className={classes.table}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>계정과목(대)</TableCell>
                    <TableCell>계정과목(중)</TableCell>
                    <TableCell>세부내역</TableCell>
                    <TableCell align="right">금액</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentCostsData.costs.map((large, lIndex) => {
                    return large.children.map((small, sIndex) => {
                      const key = `${large.id}_${small.id}`;

                      return (
                        <TableRow key={key}>
                          {sIndex === 0 && (
                            <TableCell
                              rowSpan={large?.rowSpan}
                              sx={{ width: '15%', textAlign: 'center' }}
                            >
                              {large.name}
                            </TableCell>
                          )}
                          <TableCell sx={{ width: '15%' }}>
                            {small.name}
                          </TableCell>
                          <TableCell sx={{ width: '*' }}>
                            <TextField
                              size="small"
                              required={true}
                              variant="outlined"
                              fullWidth
                              name={`${key}_desc`}
                              id={`${key}_desc`}
                              value={small.desc}
                              onChange={(e) =>
                                handleChange(
                                  e.target.value,
                                  large,
                                  small,
                                  'desc',
                                )
                              }
                            />
                          </TableCell>
                          <TableCell sx={{ width: '20%' }} align="right">
                            <TextField
                              size="small"
                              required={true}
                              variant="outlined"
                              fullWidth
                              name={`${key}_cost`}
                              id={`${key}_cost`}
                              value={small.cost}
                              onChange={(e) =>
                                handleChange(
                                  e.target.value,
                                  large,
                                  small,
                                  'cost',
                                )
                              }
                              InputProps={{
                                inputComponent: NumberFormatText,
                              }}
                            />
                          </TableCell>
                          <TableCell sx={{ width: '10%' }} align="center">
                            <IconButton
                              aria-label="delete"
                              size="small"
                              onClick={() => {
                                showDelDialog.onTrue();
                                setSelectedDel({
                                  largeId: large?.id,
                                  largeNm: large?.name,
                                  smallId: small?.id,
                                  smallNm: small?.name,
                                });
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    });
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ py: 2 }}
            >
              <Button variant="contained" color="warning" onClick={handleReset}>
                초기화
              </Button>

              <Button variant="contained" color="primary" onClick={handleSave}>
                저장
              </Button>
            </Stack>
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={1}
              sx={{ py: 1 }}
            >
              <Typography variant="subtitle2">합계</Typography>
              <Typography variant="subtitle2">
                {getNumberComma(total)} 원
              </Typography>
            </Stack>
          </Box>
        )}
      </Stack>
      {showUpload.value && (
        <TeamBudgetUploadModalContainer
          title="팀별 예산 관리"
          open={showUpload.value}
          onClose={() => {
            showUpload.onFalse();
          }}
          refreshOnClose={refreshOnClose}
        />
      )}
      {showDelDialog.value && (
        <AskDialog
          visible={showDelDialog.value}
          title=" 삭제"
          description={`해당 계정과목 [${selectedDel?.largeNm}]/[${selectedDel?.smallNm}]을  삭제 처리 하시겠습니까?(복구 불가)`}
          onConfirm={() => {
            handleDelete();
            showDelDialog.onFalse();
          }}
          onCancle={showDelDialog.onFalse}
        />
      )}
    </Box>
  );
};

export default TeamBudgetInputContainer;
